import { useEffect, useMemo } from "react";
import { useAppSelector, useAppDispatch } from "../../../store";
import { useGetWatchlistQuery } from "../../../services/ActionReports/WatchlistBff";
import { initImpersonationWatchlistItems, initWatchlistItems, setWatchlistItems } from "../../../reducers/watchlist";
import { padAff } from "../../Authentication/impersonation-util";

export interface UseWatchlistFetchParams {
  skip?: boolean;
}

export interface UseWatchlistFetchReturn {
  isLoading: boolean;
  refetch: () => void;
}

export const useWatchlistFetch = (params?: UseWatchlistFetchParams): UseWatchlistFetchReturn => {
  const dispatch = useAppDispatch();
  const { user, isImpersonation, configuration } = useAppSelector((state) => state.boot);
  const usesLocalImpersonationState =
    isImpersonation && configuration.impersonation?.disableWatchlistMutations === true;

  const { data, isLoading, isFetching, refetch } = useGetWatchlistQuery(
    { ownerAff: user.aff, ownerAbo: user.abo },
    { skip: params?.skip, refetchOnMountOrArgChange: true },
  );

  const paddedData = useMemo(() => {
    return data?.watchList
      .filter((abo) => abo.Aff !== null && abo.ABONo !== null)
      .map((abo) => ({
        ...abo,
        Aff: padAff(abo.Aff),
      }));
  }, [data]);

  useEffect(() => {
    if (usesLocalImpersonationState) {
      if (paddedData) dispatch(initImpersonationWatchlistItems(paddedData));
      return;
    }

    if (isFetching) {
      dispatch(setWatchlistItems([]));
    } else if (paddedData) {
      dispatch(initWatchlistItems(paddedData));
      dispatch(setWatchlistItems(paddedData));
    }
  }, [paddedData, isFetching, usesLocalImpersonationState, dispatch]);

  return { isLoading: isLoading || isFetching, refetch };
};
